import Requests from "@/services/Requests";
const state = {
  batteryFeatures: [],
};
const getters = {
  getBatteryFeatures: (state) => state.batteryFeatures,
  getBatteryFeatureByFeatureType: (state) => (batteryType, key) => {
    return (
      state.batteryFeatures.find(
        (f) => f.batteryType === batteryType && f.key === key
      )?.items || []
    );
  },
};
const mutations = {
  SET_BATTERY_FEATURES(state, payload) {
    state.batteryFeatures.push(payload);
  },
};

const actions = {
  async getBatteryFeatures({ state, commit }, payload) {
    try {
      if (
        state.batteryFeatures.find(
          (f) => f.key === payload.key + JSON.stringify(payload.query) && f.batteryType === payload.batteryType
        )
      )
        return true;
      const response = await Requests[payload.key].GetAll({
        query: payload.query,
      });
      if (response.message === "OK") {
        commit("SET_BATTERY_FEATURES", {
          batteryType: payload.batteryType,
          key: payload.key + JSON.stringify(payload.query),
          ...response.data,
        });
      }
      return true;
    } catch {
      return true;
    }
  },
};

export default { state, getters, mutations, actions };
